import { notification } from "antd";
import {
  UPDATE_UTILISATEUR_PASSWORD_REQUEST,
  UPDATE_UTILISATEUR_PASSWORD_SUCCESS,
  UPDATE_UTILISATEUR_PASSWORD_FAILURE,
} from "../Types";
import { apiPut } from "../../services/apiInterceptor";

export const updateUtilisateurPassword = (newPasswordData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_UTILISATEUR_PASSWORD_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token et les headers
      const response = await apiPut(
        "api/users/update-password",
        newPasswordData
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors de la mise à jour du mot de passe"
        );
      }

      dispatch({ type: UPDATE_UTILISATEUR_PASSWORD_SUCCESS, payload: data });

      notification.success({
        message: data?.message || "Mot de passe mis à jour avec succès.",
        duration: 5,
      });

      return data;
    } catch (error) {
      dispatch({
        type: UPDATE_UTILISATEUR_PASSWORD_FAILURE,
        payload: error?.message,
      });

      notification.error({
        message: error?.message || "Erreur lors du mis à jour du mot de passe",
        duration: 5,
      });
    }
  };
};
